import { del, get, post } from './client';
import type { ProductCard } from '@/types/storefront';

export interface TimelineStage {
  stage: 'RECEIVED' | 'CONFIRMED' | 'PREPARING' | 'OUT_FOR_DELIVERY' | 'DELIVERED';
  label: string;
  description: string;
  completed: boolean;
  current: boolean;
  /** Aşamaya geçilmediyse veya kayıt yoksa null — uydurulmaz. */
  occurredAt: string | null;
}

export interface TrackingView {
  orderNo: string;
  placedAt: string;
  timeline: TimelineStage[];
  isCancelled: boolean;
  cancelledAt: string | null;
  delivery: {
    date: string;
    slotLabel: string;
    zoneName: string;
    deliveredAt: string | null;
    addressUnknown: boolean;
    addressPreview: string | null;
  };
  recipientName: string;
  senderName: string | null;
  isAnonymous: boolean;
  cardMessage: string | null;
  payment: {
    methodLabel: string;
    statusLabel: string;
    awaitingTransfer: boolean;
  };
  items: Array<{
    name: string;
    variantLabel: string | null;
    quantity: number;
    imageUrl: string | null;
    addons: Array<{ name: string; quantity: number }>;
  }>;
  totals: {
    subtotal: string;
    discount: string;
    deliveryFee: string;
    total: string;
  };
  proofPhoto: { url: string; alt: string } | null;
}

export const trackingApi = {
  byPhone: (orderNo: string, phone: string) =>
    post<TrackingView>('/tracking', { orderNo, phone }),
  byToken: (orderNo: string, token: string) =>
    get<TrackingView>(`/tracking/${orderNo}`, { params: { token } }),
};

// --- Favoriler -------------------------------------------------------------

export const favoritesApi = {
  list: (zone?: string) =>
    get<ProductCard[]>('/favorites', { params: zone ? { zone } : undefined }),
  slugs: () => get<string[]>('/favorites/slugs'),
  add: (slug: string) => post<{ added: boolean }>('/favorites', { slug }),
  remove: (slug: string) =>
    del<{ removed: boolean }>(`/favorites/${encodeURIComponent(slug)}`),
  merge: (deviceId: string, slugs: string[]) =>
    post<{ merged: number; total: number }>('/favorites/merge', { deviceId, slugs }),
};

// --- Arama -----------------------------------------------------------------

export interface ParsedSearch {
  text: string;
  priceMin?: string;
  priceMax?: string;
  sameDay?: boolean;
  hints: string[];
}

export interface SearchSuggestResult {
  items: ProductCard[];
  parsed: ParsedSearch;
  total: number;
}

export const searchApi = {
  suggest: (term: string, zone?: string) =>
    get<SearchSuggestResult>('/products/search', {
      params: { q: term, ...(zone ? { zone } : {}) },
    }),
};
